import React, { ReactNode } from "react";

import { green, blue, amber, red } from "@mui/material/colors";
import Box from "@mui/material/Box";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";

export const Alert = (props: { severity: "error" | "info" | "success" | "warning"; children?: ReactNode }) => {
  const { severity } = props;

  let Icon = InfoIcon;
  let color: any = blue;

  switch (severity) {
    case "success": {
      Icon = CheckCircleOutlineIcon;
      color = green;
      break;
    }
    case "warning": {
      Icon = WarningIcon;
      color = amber;
      break;
    }
    case "error": {
      Icon = ErrorOutlineIcon;
      color = red;
      break;
    }
  }
  const backgroundColor = color["50"];
  const iconColor = color["600"];
  const textColor = color["900"];
  return (
    <Box alignItems="center" bgcolor={backgroundColor} borderRadius={4} display="flex" mb={2} px={2} py={1}>
      <Box mr={2} color={iconColor}>
        <Icon fontSize="small" />
      </Box>
      <Box color={textColor}>
        <Box fontSize={14}>{props.children}</Box>
      </Box>
    </Box>
  );
};
